import React, { useState } from 'react'
import { Button, DatePicker, message, Popconfirm } from 'antd'
import moment from 'moment'
import { updateNextBoxFromDiary, deleteNextBoxFromDiary } from '../../../../services/api/apiNextBoxDiary'

function NextBoxDiaryDetailsHeader(props) {
    const { listSelecteds = [], openAction, toggleAction, currentDate, detailsId, reset } = props
    const [isOpenDatePicker, setIsOpenDatePicker] = useState(false)
    const [selectedDate, setSelectedDate] = useState(currentDate ? moment(currentDate).format('DD/MM/YYYY') : '')
    const [showConfirm, setShowConfirm] = useState(false)

    const onSelectDate = async (date) => {
        setSelectedDate(date)
        setShowConfirm(true)
    }

    const disabledDate = (current) => {
        return current && current > moment().endOf('day')
    }

    const confirmDate = async () => {
        setShowConfirm(false)
        setIsOpenDatePicker(false)
        try {
            const payload = {
                date: selectedDate ? moment(selectedDate).format('DD/MM/YYYY') : '',
                boxes: listSelecteds
            }
            const { data: res } = await updateNextBoxFromDiary(detailsId, { ...payload })
            const { success, message: mess } = { ...res }
            if (!success) {
                throw new Error(mess)
            }
            message.success(`${listSelecteds.length} Thùng đã được chuyển đến ngày ${selectedDate ? moment(selectedDate).format('DD/MM/YYYY') : ''}.`)
            reset(detailsId)
        } catch (error) {
            message.error(error.message)
        }
    }

    const cancelDate = () => {
        setShowConfirm(false);
        setSelectedDate(currentDate ? moment(currentDate).format('DD/MM/YYYY') : '')
    }

    const dateRender = (current) => {
        const isSelected = current.isSame(selectedDate, 'day')
        return (
            <div className="ant-picker-cell-inner">
                <Popconfirm
                    title={`Bạn có chắc chắn muốn chọn ngày ${current.format('DD/MM/YYYY')}?`}
                    visible={showConfirm && isSelected}
                    onConfirm={confirmDate}
                    onCancel={cancelDate}
                    okText="Yes"
                    cancelText="No"
                >
                    <div onClick={() => onSelectDate(current)}>
                        {current.date()}
                    </div>
                </Popconfirm>
            </div>
        )
    }

    const toggleDatePicker = () => {
        setIsOpenDatePicker(!isOpenDatePicker)
        setSelectedDate('')
    }

    const handleClickOutsideDatePicker = () => {
        setIsOpenDatePicker(false)
        setSelectedDate('')
        setShowConfirm(false)
    }

    const onDelete = async () => {
        try {
            const payload = {
                boxes: listSelecteds
            }
            const { data: res } = await deleteNextBoxFromDiary(detailsId, { ...payload })
            const { success, message: mess } = { ...res }
            if (!success) {
                throw new Error(mess)
            }
            message.success(`${listSelecteds.length} Thùng đã được xóa khỏi nhật ký.`)
            reset(detailsId)
        } catch (error) {
            message.error(error.message)
        }
    }

    return (
        <thead className="TableHead NextBoxDiaryDetailsHeader">
            {listSelecteds.length > 0 ?
                <tr>
                    <th colSpan={4}>
                        <div className="d-flex align-items-center">
                            {/* <Checkbox checked={selectedAll} onChange={(e) => handleChangeSelectAll(e.target.checked)} /> */}
                            <div className="CustomSelect mx-3">
                                <Button
                                    onClick={toggleAction}
                                    className="dropdown-toggle">Actions</Button>
                                <div className={openAction ? 'ListAction open' : 'ListAction'}>
                                    <Popconfirm
                                        title={`Bạn có chắc chắn muốn xóa ${listSelecteds.length} thùng ?`}
                                        okText="Yes"
                                        cancelText="No"
                                        onConfirm={onDelete}
                                    >
                                        <Button
                                            color="link"
                                            className="mr-1"
                                        >
                                            Xóa thùng
                                        </Button>
                                    </Popconfirm>
                                    <Button
                                        color="link"
                                        className="mr-1"
                                        onClick={toggleDatePicker}
                                    >
                                        Đổi ngày
                                    </Button>
                                    <div className="DiaryNextBoxesSelectDate">
                                        {
                                            isOpenDatePicker &&
                                            <div className='DiaryNextBoxesSelectDateOverlay' onClick={() => handleClickOutsideDatePicker()}></div>
                                        }
                                        <DatePicker
                                            className="mcHiddenInput"
                                            value={selectedDate ? moment(selectedDate, 'DD/MM/YYYY') : ''}
                                            open={isOpenDatePicker}
                                            format={'DD/MM/YYYY'}
                                            disabledDate={disabledDate}
                                            onChange={onSelectDate}
                                            inputReadOnly
                                            dateRender={dateRender}
                                        />
                                    </div>
                                </div>
                            </div>
                            <strong>{listSelecteds.length} {listSelecteds.length !== 1 ? 'boxes' : 'box'} selected</strong>
                        </div>
                    </th>
                </tr> :
                <tr>
                    {/* <td><Checkbox checked={selectedAll} onChange={(e) => handleChangeSelectAll(e.target.checked)} /></td> */}
                    <td>Shipping carrier</td>
                    <td>Tổng số thùng/Tổng số đơn VN</td>
                    <td className='BoxNumberAndBarCode'>Mã thùng/Mã đơn VN</td>
                </tr>
            }
        </thead>
    )
}

export default NextBoxDiaryDetailsHeader